module.exports = __webpack_public_path__ + "img/13-2.fc7ec266.png";